import React, { FC } from 'react';
import styled from 'styled-components';

interface TabItemProps {
  isActive?: boolean;
  isSmall?: boolean;
  role?: string;
  onClick: () => void;
}

export const TabItem: FC<TabItemProps> = ({ ...props }) => <StyledTabButton {...props} />;

const StyledTabButton = styled.button<TabItemProps>`
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.palette.textInactive};
  cursor: pointer;
  display: inline-block;
  font-size: ${({ isSmall, theme }) => (isSmall ? theme.fontSize.small : theme.fontSize.large)};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  line-height: ${({ theme }) => theme.lineHeight.ui};
  padding: ${({ theme }) => `${theme.px.small} ${theme.px.base}`};
  user-select: none;

  ${({ isActive, theme }) =>
    isActive &&
    `
        background: ${theme.palette.background5};
        color: ${theme.palette.textDefault};
    `}
`;
